// AUTOGENERATED: DO NOT EDIT

import { Assets } from "pixi.js";
import boyademlad2 from "../../assets/img/lad/boyadem-lad-2.png";
import boyademlad3 from "../../assets/img/lad/boyadem-lad-3.png";
import boyademladsprite3 from "../../assets/img/lad/boyadem-lad-sprite-3.png";
import boyademladswipe2 from "../../assets/img/lad/boyadem-lad-swipe-2.png";
import boyademladswipe from "../../assets/img/lad/boyadem-lad-swipe.png";
import boyademlad from "../../assets/img/lad/boyadem-lad.png";
import ratfink from "../../assets/img/ratfink/ratfink.png";
import scanding from "../../assets/img/scanner/scan-ding.png";
import scangrind from "../../assets/img/scanner/scan-grind.png";
import scanidle from "../../assets/img/scanner/scan-idle.png";
import water from "../../assets/img/tile/water.png";

export const loadSpritesheets = async () => {
  Assets.load([
    boyademlad2,
    boyademlad3,
    boyademladsprite3,
    boyademladswipe2,
    boyademladswipe,
    boyademlad,
    ratfink,
    scanding,
    scangrind,
    scanidle,
    water,
  ]);
};
